import React from 'react'
import Login from './login'
import SignUp from './signup'
import {useSelectedModule}  from '../redux/navigation'

export default function RenderRoute() {
    const selectedMod = useSelectedModule()
    switch (selectedMod) {
        case 'Login':
            return <Login />
        case 'SignUp':
            return <SignUp />
        default:
            return <Login/>
    }
}